import Faq from '@sunbit-dev/ui/src/components/ui/faq/Faq';
import { faqData } from '../utils/data/faq/faqData';
import React from 'react';
import { Route, Switch } from 'react-router';
import { useDispatch } from 'react-redux';
import ApprovalTermsContainer from '../containers/ApprovalTermsContainer';
import CardApplyLayoutContainer from '../containers/CardApplyLayoutContainer';
import DocumentContainer from '../containers/DocumentContainer';
import ErrorHandlerContainer from '../containers/ErrorHandlerContainer';
import ExistingApplicationContainer from '../containers/ExistingApplicationContainer';
import IdentificationContainer from '../containers/IdentificationContainer';
import LoaderContainer from '../containers/LoaderContainer';
import PaymentDetailsContainer from '../containers/PaymentDetailsContainer';
import ThanksContainer from '../containers/ThanksContainer';
import ScrollToTop from './ScrollToTop';
import ContactUsContainer from '../containers/ContactUsContainer';
import ErrorContainer from '../containers/ErrorPageContainer';
import PlasticAddressContainer from '../containers/plasticAddressContainer';
import WelcomerPopupContainer from '../containers/WelcomerPopupContainer';
import BeforeExitDialogContainer from '../containers/BeforeExitDialogContainer';
import URLS from '../constants/urls';
import ThemeProvider from '@sunbit-dev/ui/src/components/themes/ThemeProvider';
import CardApplyGlobalStyle from '../styles/GlobalStyle';
import theme from '../styles/theme';
import { VerificationContainer } from '../containers/VerificationContainer';
import { sunbitFeatureStore } from '../services/launchDarkly';
import { ActionTypes as InitialDetailsActionTypes } from '../actions/initialDetailsActions';
import { ERROR_CODES } from '../errors/errors';
import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';

declare let window: any;
const App: React.FC = () => {
  const dispatch = useDispatch();
  const isMaintenanceMode = sunbitFeatureStore.getFeatureFlagValue('card-maintenance-mode');

  React.useLayoutEffect(() => {
    if (isMaintenanceMode) {
      dispatch({
        type: InitialDetailsActionTypes.getInitialDetails,
        status: ActionStatus.Failure,
        error: { code: ERROR_CODES.downForMaintenance },
      });
    }
  }, [isMaintenanceMode, dispatch]);

  if (isMaintenanceMode) {
    return (
      <ThemeProvider theme={theme}>
        <CardApplyGlobalStyle />
        <ErrorHandlerContainer />
        <Switch>
          <CardApplyLayoutContainer>
            <Route exact path={URLS.error} component={ErrorContainer} />
          </CardApplyLayoutContainer>
        </Switch>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CardApplyGlobalStyle />
      <LoaderContainer />
      <ErrorHandlerContainer />
      <ScrollToTop />
      <PlasticAddressContainer />
      <WelcomerPopupContainer />
      {window.DISABLE_DONT_LEAVE_PROMPT !== 'true' && <BeforeExitDialogContainer />}{' '}
      {/* disabled on automation until we will find a way to close browser native prompt and reload the page. */}
      <Switch>
        <Route exact path="/document" component={DocumentContainer} />
        <CardApplyLayoutContainer>
          <Route exact path={URLS.application} component={IdentificationContainer} />
          <Route exact path={URLS.applicationExistingApplication} component={ExistingApplicationContainer} />
          <Route exact path={URLS.applicationApprovalTerms} component={ApprovalTermsContainer} />
          <Route exact path={URLS.applicationPaymentDetails} component={PaymentDetailsContainer} />
          <Route exact path={URLS.applicationThanks} component={ThanksContainer} />
          <Route exact path={URLS.verification} component={VerificationContainer} />
          <Route exact path={URLS.contactUs} component={ContactUsContainer} />
          <Route exact path={URLS.error} component={ErrorContainer} />
          <Route
            exact
            path={URLS.frequentlyAskedQuestions}
            component={() => <Faq faqTitle="Sunbit Card - Frequently Asked Questions" faqData={faqData} />}
          />
        </CardApplyLayoutContainer>
      </Switch>
    </ThemeProvider>
  );
};

export default App;
